import { render } from "./KeranjangView.vue?vue&type=template&id=660c1bc9"
import script from "./KeranjangView.vue?vue&type=script&lang=js"
export * from "./KeranjangView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBreadcrumbs from 'quasar/src/components/breadcrumbs/QBreadcrumbs.js';
import QBreadcrumbsEl from 'quasar/src/components/breadcrumbs/QBreadcrumbsEl.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QRating from 'quasar/src/components/rating/QRating.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBreadcrumbs,QBreadcrumbsEl,QImg,QBtn,QCard,QSpinnerIos,QCardSection,QRating,QDialog,QCardActions});qInstall(script, 'directives', {Ripple,ClosePopup});
